/* Brand Guide can be found here:
  https://www.figma.com/design/pq1k56FA7IiAsjgZ6QyQuJ/Approveshield-Brandguide?node-id=179-81&t=kZ9D3wJ9RcrtMCZ1-0
  When making changes here also update _variables.scss file
*/

export const PALETTE = {
  red: "rgb(196, 58, 0)",
  red50: "rgb(254,237,230)",
  red100: "rgb(254, 288, 217)",
  red200: "rgb(252,199,176)",
  red300: "rgb(245,73, 0)",
  red400: "rgb(211, 66, 0)",
  green: "rgb(54,186,111)",
  green50: "rgb(235,248,241)",
  green100: "rgb(163,223,189)",
  green200: "rgb(163,223,189)",
  green300: "rgb(94,200,140)",
  green400: "rgb(94,200,140)",
  blue: "rgb(68,85,204)",
  blue25: "rgb(244,245,254)",
  blue50: "rgb(236,238,250)",
  blue100: "rgb(227,230,247)",
  blue200: "rgb(197,202,239)",
  blue300: "rgb(68,85,204)",
  blue400: "rgb(61,77,184)",
  blue500: "rgb(54,68,163)",
  blue600: "rgb(51,64,153)",
  blue700: "rgb(41,51,122)",
  blue800: "rgb(31,38,92)",
  blue900: "rgb(24,30,71)",
  yellow: "rgb(245,220,0)",
  yellow50: "rgb(255,245,219)",
  yellow100: "rgb(255,245,219)",
  yellow200: "rgb(255,233,176)",
  yellow300: "rgb(245,220,0)",
  orange: "rgb(255, 118, 0)",
  orange50: "rgb(255,241,230)",
  orange100: "rgb(255,235,217)",
  orange200: "rgb(255,213,176)",
  orange300: "rgb(255,119,0)",
  orange400: "rgb(230,107,0)",
  white: "rgb(255,255,255)",
  grey50: "rgb(254,250,255)",
  grey100: "rgb(252,250,255)",
  grey200: "rgb(251,249,255)",
  grey300: "rgb(228,227,232)",
  grey400: "rgb(178,177,181)",
  grey500: "rgb(138,137,140)",
  grey600: "rgb(105,105,107)",
};

export const theme = {
  primary: PALETTE.blue,
  secondary: PALETTE.orange,
  warning: PALETTE.yellow,
  info: PALETTE.blue100,
  success: PALETTE.green,
  danger: PALETTE.red,
  light: PALETTE.grey50,
  lightPrimary: PALETTE.blue25,
  dark: PALETTE.grey600,
  darkPrimary: PALETTE.blue700,
};
